export default __webpack_public_path__ + "static/media/KOD0158-min.d6236fd9.webp";